import { render, staticRenderFns } from "./IntegrateWithFrameworkEasily.vue?vue&type=template&id=7a70a158&scoped=true"
import script from "./IntegrateWithFrameworkEasily.vue?vue&type=script&lang=js"
export * from "./IntegrateWithFrameworkEasily.vue?vue&type=script&lang=js"
import style0 from "./IntegrateWithFrameworkEasily.vue?vue&type=style&index=0&id=7a70a158&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a70a158",
  null
  
)

export default component.exports